/** Turning the judge's two score trees into one ordered list of shortfalls. */

import { num, rec, type ScorePart } from './verdict-readers';

export interface CriterionScore {
  key: string;
  label: string;
  max: number;
  ai: number | null;
  human: number | null;
  /** Positive when the agent scored higher; null when either side is missing. */
  gap: number | null;
}

/** Criteria the judge scored, worst shortfall first; one neither side was scored on is dropped. */
export function rankByGap(parts: ReadonlyArray<ScorePart>, subScores: Record<string, unknown> | null): CriterionScore[] {
  const aiParts = rec(subScores?.['ai']);
  const humanParts = rec(subScores?.['human']);
  return parts
    .map((part) => {
      const ai = num(aiParts?.[part.key]);
      const human = num(humanParts?.[part.key]);
      return { key: part.key, label: part.label, max: part.max, ai, human, gap: ai !== null && human !== null ? human - ai : null };
    })
    .filter((c) => c.ai !== null || c.human !== null)
    .sort((a, b) => (b.gap ?? -Infinity) - (a.gap ?? -Infinity));
}

/** Position on a 0-100 track, clamped so an out-of-range score fills rather than overflows. */
export const trackPct = (value: number | null, max: number): number =>
  max <= 0 ? 0 : Math.max(0, Math.min(100, ((value ?? 0) / max) * 100));
